import React from "react";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Flags } from "../../../feature-flags/flags";

export const Unauthorized = () => {
    const { enabled: enableRebrand } = useFeatureFlag(Flags.ENABLE_REBRAND);
    return <opti-no-access {...(enableRebrand && { version: "2" })}></opti-no-access>;
};

Unauthorized.displayName = "Unauthorized";
